import { BelieveMakePaymentContext } from 'features/believe/makePayment/provider/BelieveMakePaymentProvider';
import { useContext } from 'react';

export const useMakePayment = () => useContext(BelieveMakePaymentContext);
